import { useEffect, useMemo, useState } from 'preact/hooks';
import { carregarGeo, useApi } from './hooks';
import type { Secretaria } from './types';

export type MunicipioRef = { cod: string; nome: string; mesorregiao: string };

/** Os 223 municípios, em ordem alfabética, com busca de nome por código. */
export function useMunicipios() {
  const [lista, setLista] = useState<MunicipioRef[]>([]);
  useEffect(() => {
    let vivo = true;
    carregarGeo().then((g) => {
      if (!vivo) return;
      setLista(
        g.features
          .map((f) => ({ cod: f.properties.codIbge, nome: f.properties.nome, mesorregiao: f.properties.mesorregiao }))
          .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR')),
      );
    });
    return () => {
      vivo = false;
    };
  }, []);
  const porCod = useMemo(() => new Map(lista.map((m) => [m.cod, m])), [lista]);
  return { lista, porCod, nome: (cod: string) => porCod.get(cod)?.nome ?? cod };
}

/** Secretarias que o usuário pode ver (a API já filtra pelo escopo dele). */
export function useSecretarias() {
  const c = useApi<Secretaria[]>('/secretarias');
  const lista = c.dados ?? [];
  const porId = useMemo(() => new Map(lista.map((s) => [s.id, s])), [c.dados]);
  return { ...c, lista, porId };
}
